var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBackArrow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "42px",
    viewBox: "0 0 42 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MIS-CURSOS",
    transform: "translate(-53.000000, -952.000000)",
    fill: "#004591"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.2529594,957.524167 C88.2522038,954.100605 81.8079087,952 74,952 C66.1920913,952 59.7477962,954.100605 56.7470406,957.524167 C51.7509865,963.319982 51.7509865,982.723362 56.7470406,988.47785 C59.7477962,991.899447 66.1920913,994 74,994 C81.8079087,994 88.2522038,991.899396 91.2529594,988.47785 C96.2490135,982.680019 96.2490135,963.319982 91.2529594,957.524167 Z M77.4848459,978.774144 C78.352632,979.539947 78.4372093,980.864871 77.673747,981.735049 C77.2742994,982.189814 76.7016875,982.449698 76.0995718,982.449698 C75.5879775,982.449698 75.0960289,982.262675 74.7142977,981.924043 L66.3180254,974.57495 C65.8654487,974.177277 65.6076568,973.602412 65.6076568,973.000001 C65.6076568,972.397589 65.8654286,971.822745 66.3180254,971.425051 L74.7142977,964.075958 C75.1275174,963.678284 75.6843926,963.467649 76.2550248,963.491236 C76.8276215,963.514863 77.3648056,963.772756 77.7426077,964.201954 C78.1223793,964.633097 78.3073462,965.198128 78.2581311,965.769041 C78.2089363,966.339954 77.929524,966.865609 77.4847956,967.225857 L70.8929057,973.000001 L77.4848459,978.774144 Z",
    id: "Fill-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBackArrow);
export default __webpack_public_path__ + "static/media/ICON_back_arrow.b7045ff5b2444746939af60cd6b0a36f.svg";
export { ForwardRef as ReactComponent };